import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, CircularProgress, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import IconComponent from "../../../common/components/IconComponent";
import { IExpressionEvaluatorContext } from "../../../ExpressionsModule/Models/IExpressionEvaluatorContext";
import { TableColumnActionModel } from "../../Models/TableColumnActionModel";
import PanelAction from "../Panel/PanelAction";

type ListPanelHeaderProps = {
  title?: React.ReactNode;
  iconName?: string;
  refreshTitle?: string;
  refreshAriaLabel?: string;
  isRefreshing?: boolean;
  showRefresh?: boolean;
  onRefresh?: () => void;
  leadingActions?: React.ReactNode;
  actions?: TableColumnActionModel[];
  actionData?: any;
  context: IExpressionEvaluatorContext;
  ownerComponentId: string;
  ownerComponentPath: string[];
};

const ListPanelHeader: React.FC<ListPanelHeaderProps> = ({
  title,
  iconName,
  refreshTitle = "Refresh items",
  refreshAriaLabel = "refresh items",
  isRefreshing,
  showRefresh,
  onRefresh,
  leadingActions,
  actions,
  actionData,
  context,
  ownerComponentId,
  ownerComponentPath,
}) => {
  const hasHeader = !!title || !!iconName || !!leadingActions || showRefresh || !!actions?.length;
  if (!hasHeader) {
    return null;
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", minHeight: 48, px: 2, py: 1, gap: 1 }}>
        {iconName && <IconComponent iconName={iconName} size="small" />}
        {title ? (
          <Typography variant="subtitle1" fontWeight={600} sx={{ flex: 1, minWidth: 0 }}>
            {title}
          </Typography>
        ) : (
          <Box sx={{ flex: 1 }} />
        )}
        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
          {leadingActions}
          {showRefresh && (
            <Tooltip title={refreshTitle}>
              <span>
                <IconButton size="small" onClick={onRefresh} disabled={isRefreshing} aria-label={refreshAriaLabel}>
                  {isRefreshing ? <CircularProgress size={18} /> : <RefreshIcon fontSize="small" />}
                </IconButton>
              </span>
            </Tooltip>
          )}
          {!!actions?.length && (
            <PanelAction actions={actions} size="small" formatData={actionData} context={context} ownerComponentId={ownerComponentId} ownerComponentPath={ownerComponentPath} />
          )}
        </Box>
      </Box>
      <Divider />
    </>
  );
};

export default ListPanelHeader;
